import { ref } from 'vue';
import { defineStore } from "pinia";
import { CompletedchecksService, type CompletedCheckDto } from '@/client';

export const useCompletedCheckStore = defineStore("completedcheck", () => {

    async function getCompletedCheck(id:number) {
        return await CompletedchecksService.getApiCompletedchecksById({id})
        .then((response) => {
            return Promise.resolve(response);
        })
        .catch((error:any) => {
            return Promise.reject(error);
        })
    }

    async function getCompletedChecksByDateRange(from:string, to:string) {
        return await CompletedchecksService.getApiCompletedchecksBydate({from, to})
        .then((response) => {
            return Promise.resolve(response);
        })
        .catch((error:any) => {
            return Promise.reject(error);
        })
    }

    async function addRetrospectiveCheck(completedCheck:CompletedCheckDto) {
        return await CompletedchecksService.postApiCompletedchecksSaveretroactive({requestBody: completedCheck})
        .then((response) => {
            return Promise.resolve(response);
        }).catch((error:any) => {
            return Promise.reject(error);
        });
    }


    return {
        getCompletedCheck,
        getCompletedChecksByDateRange,
        addRetrospectiveCheck    
    };
});